import type { DropdownOption } from '~/components/Dropdown';
import type { BaseEntity, LabelDetail } from '~settings/api/lib/schemas';

const SOCIAL_KEYS = [
  'facebookReference',
  'twitterReference',
  'website',
  'youtubeReference',
  'instagramReference',
] as const;

type SOCIAL_KEYS = (typeof SOCIAL_KEYS)[number];

export interface LabelDetailTransformed extends LabelDetail {
  isSublabel: boolean;
  socials: [SOCIAL_KEYS, string][];
  adminUsers: LabelDetail['users'];
}

export const transformLabelDetails = (
  labelDetail: LabelDetail,
): LabelDetailTransformed => {
  const socials = SOCIAL_KEYS.reduce((acc: [SOCIAL_KEYS, string][], key) => {
    if (labelDetail[key]) {
      let value = labelDetail[key];

      if (!/^(https?:)/.test(value)) {
        value = `https://${value}`;
      }

      acc.push([key, value]);
    }

    return acc;
  }, []);

  return {
    ...labelDetail,
    isSublabel: Boolean(labelDetail.parentId),
    socials,
    adminUsers: labelDetail.users.filter((user) =>
      user.roles.some((role) => role === 'LABEL_ADMIN'),
    ),
  };
};

export function toDropdownList<T extends string>(
  list: ({ id: T } & Record<string, unknown>)[] = [],
  property = 'name',
): { value: T; label: string }[] {
  return list.reduce<DropdownOption<T>[]>((acc, next) => {
    if (next.id !== undefined && String(next[property] ?? '')) {
      acc.push({
        value: next.id,
        label: String(next[property]),
      });
    }

    return acc;
  }, []);
}

export function fromDropdownList<T extends string>(
  list: DropdownOption<T>[] = [],
): BaseEntity[] {
  return list.map((item) => ({
    id: item.value,
    name: item.label,
  }));
}
